import { DashboardModel } from "@core/services/api.service";

export class LoadDashboardsAction {
  static readonly type = '[Dashboards] Load Dashboard Metrics';
  constructor() { }
}

export class LoadDashboardsSuccessAction {
  static readonly type = '[Dashboards] Load Dashboard Success';

  constructor(public payload: { dashboards: DashboardModel[] }) { }
}

export class LoadDashboardsFailAction {
  static readonly type = '[Dashboards] Load Dashboard Fail';
}

export class LoadControlTowerDashboardsV1Action {
    static readonly type = '[ControlTowerDashboardsV1] Load Control Tower Dashboards V1 Metrics';
    constructor() { }
}

export class LoadControlTowerDashboardsV1SuccessAction {
    static readonly type = '[ControlTowerDashboardsV1] Load Control Tower Dashboards V1 Success';

    constructor(public payload: { dashboards: DashboardModel[] }) { }
}

export class LoadControlTowerDashboardsV1FailAction {
    static readonly type = '[ControlTowerDashboardsV1] Load Control Tower Dashboards V1 Fail';
}

export class LoadCustomsDashboardsV1Action {
    static readonly type = '[CustomsDashboard] Load Customs Dashboard';
    constructor() { }
}

export class LoadCustomsDashboardsV1SuccessAction {
    static readonly type = '[CustomsDashboard] Load Customs Dashboards Success';

    constructor(public payload: { dashboards: DashboardModel[] }) { }
}

export class LoadCustomsDashboardsV1FailAction {
    static readonly type = '[CustomsDashboard] Load Customs Dashboards Fail';
}

export class LoadNoVehicleDashboardsAction {
    static readonly type = '[NoVehicleDashboards] Load No Vehicle Dashboards';
    constructor() { }
}

export class LoadNoVehicleDashboardsSuccessAction {
    static readonly type = '[NoVehicleDashboards] Load No Vehicle Dashboards Success';

    constructor(public payload: { dashboards: DashboardModel[] }) { }
}

export class LoadNoVehicleDashboardsFailAction {
    static readonly type = '[NoVehicleDashboards] Load No Vehicle Dashboards Fail';
}

export class LoadCollectPodJobCountAction {
    static readonly type = '[CollectPodJobCount] Load Collect POD Job Count';
    constructor() { }
}

export class LoadCollectPodJobCountSuccessAction {
    static readonly type = '[CollectPodJobCount] Load Collect POD Job Count Success';

    constructor(public payload: { dashboards: DashboardModel[] }) { }
}

export class LoadCollectPodJobCountFailAction {
    static readonly type = '[CollectPodJobCount] Load Collect POD Job Count Fail';
}

export class LoadPodOnlyJobCountAction {
    static readonly type = '[PodOnlyJobCount] Load POD Only Job Count';
    constructor() { }
}

export class LoadPodOnlyJobCountSuccessAction {
    static readonly type = '[PodOnlyJobCount] Load POD Only Job Count Success';

    constructor(public payload: { dashboards: DashboardModel[] }) { }
}

export class LoadPodOnlyJobCountFailAction {
    static readonly type = '[PodOnlyJobCount] Load POD Only Job Count Fail';
}

export class LoadBmwJobCountAction {
    static readonly type = '[BmwJobCount] Load BMW Job Count';
    constructor() { }
}

export class LoadBmwJobCountSuccessAction {
    static readonly type = '[BmwJobCount] Load BMW Job Count Success';

    constructor(public payload: { dashboards: DashboardModel[] }) { }
}

export class LoadBmwJobCountFailAction {
    static readonly type = '[BmwJobCount] Load BMW Job Count Fail';
}

export class LoadBmwCollectionTrackingWarningCountAction {
    static readonly type = '[BmwCollectionTrackingWarningCount] Load BMW Collection Tracking Warning Count';
    constructor() { }
}

export class LoadBmwCollectionTrackingWarningCountSuccessAction {
    static readonly type = '[BmwCollectionTrackingWarningCount] Load BMW Collection Tracking Warning Count Success';

    constructor(public payload: { dashboards: DashboardModel[] }) { }
}

export class LoadBmwCollectionTrackingWarningCountFailAction {
    static readonly type = '[BmwCollectionTrackingWarningCount] Load BMW Collection Tracking Warning Count Fail';
}

export class LoadBmwNoLocationWarningCountAction {
    static readonly type = '[BmwNoLocationWarningCount] Load BMW No Location Warning Count';
    constructor() { }
}

export class LoadBmwNoLocationWarningCountSuccessAction {
    static readonly type = '[BmwNoLocationWarningCount] Load BMW No Location Warning Count Success';

    constructor(public payload: { dashboards: DashboardModel[] }) { }
}

export class LoadBmwNoLocationWarningCountFailAction {
    static readonly type = '[BmwNoLocationWarningCount] Load BMW No Location Warning Count Fail';
}
